export default "__VITE_ASSET__CnWZIw3v__"